module.exports = __webpack_public_path__ + "static/media/Brawlbay_Banner_Gradient_lighter.19aed5eb.jpg";